export const DEFAULT_TITLE = 'Forventet årlig energiforbrug';

export const DEFAULT_WEIGHTS = [0.16, 0.13, 0.1, 0.07, 0.05, 0.04, 0.03, 0.03, 0.04, 0.09, 0.12, 0.14];
